import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import { FaCalendarAlt, FaChartBar, FaUsers, FaUserGraduate, FaUserPlus, FaSchool, FaUser } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import PieChartDistribution from '../components/Charts/PieChartDistribution';
import SingleBarChart from '../components/Charts/SingleBarChart';
//import BarChartProspectos from '../components/Charts/BarChartProspectos';
// import BarChartBajas from '../components/Charts/BarChartBajas';
//import BarChartAlumnos from '../components/Charts/BarChartAlumnos';
import LineChartProspectosAlumnos from '../components/Charts/LineChartProspectosAlumnos';

import api from '../services/axios';
import '../styles/DashboardPage.css';

function parseDateString(dateString) {
  // Convierte 'YYYY-MM-DD' a objeto Date
  if (!dateString) return null;
  const [year, month, day] = dateString.split('-');
  return new Date(year, month - 1, day);
}

function formatDateToString(date) {
  // Convierte objeto Date a 'YYYY-MM-DD'
  if (!date) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

function DashboardPage() {
  const navigate = useNavigate();

  const getYearDates = () => {
    const currentYear = new Date().getFullYear();
    return {
      start: `${currentYear}-01-01`,
      end: `${currentYear}-12-31`
    };
  };

  const { start: initialStart, end: initialEnd } = getYearDates();
  const [startDate, setStartDate] = useState(initialStart);
  const [endDate, setEndDate] = useState(initialEnd);
  const [isFilterChanged, setIsFilterChanged] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [error, setError] = useState('');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1025);

  useEffect(() => {
    const token = localStorage.getItem('token'); 
    if (!token) {
      setError('No estás autenticado. Por favor inicia sesión.');
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    fetchDashboardData();
  }, [startDate, endDate]);

  useEffect(() => {
    const interval = setInterval(() => {
      const newDates = getYearDates();
      setStartDate(prev => (prev !== newDates.start ? newDates.start : prev));
      setEndDate(prev => (prev !== newDates.end ? newDates.end : prev));
    }, 86400000);

    return () => clearInterval(interval);
  }, []);

  // DATOS MOCK PARA FUNCIONAMIENTO TEMPORAL SIN BACKEND
  const getMockDashboardData = () => {
    return {
      total_prospectos: 150,
      total_alumnos: 89,
      total_bajas: 12,
      prospectos_por_mes: [
        { mes: 'Enero', cantidad: 25 },
        { mes: 'Febrero', cantidad: 30 },
        { mes: 'Marzo', cantidad: 28 },
        { mes: 'Abril', cantidad: 35 },
        { mes: 'Mayo', cantidad: 32 },
        { mes: 'Junio', cantidad: 40 }
      ],
      bajas_por_mes: [
        { mes: 'Enero', cantidad: 2 },
        { mes: 'Febrero', cantidad: 1 },
        { mes: 'Marzo', cantidad: 3 },
        { mes: 'Abril', cantidad: 2 },
        { mes: 'Mayo', cantidad: 1 },
        { mes: 'Junio', cantidad: 3 }
      ],
      alumnos_por_mes: [
        { mes: 'Enero', cantidad: 15 },
        { mes: 'Febrero', cantidad: 18 },
        { mes: 'Marzo', cantidad: 20 },
        { mes: 'Abril', cantidad: 22 },
        { mes: 'Mayo', cantidad: 25 },
        { mes: 'Junio', cantidad: 28 }
      ],
      distribucion_prospectos: [
        { nombre: 'Nuevos', cantidad: 80 },
        { nombre: 'En seguimiento', cantidad: 45 },
        { nombre: 'Convertidos', cantidad: 25 }
      ]
    };
  };

  const fetchDashboardData = async () => {
    try {
      const response = await api.get('/dashboard/reporte', {
        params: {
          fecha_inicio: startDate,
          fecha_fin: endDate,
        },
      });
      setDashboardData(response.data.data);
      
    } catch (err) {
      setError('Error al obtener los datos del dashboard');
    }
  };

  const resetFilters = () => {
    const newDates = getYearDates();
    setStartDate(newDates.start);
    setEndDate(newDates.end);
    setIsFilterChanged(false);
  };

  const handleDateChange = () => {
    setIsFilterChanged(true);
  };

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1025;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(true);
      } else {
        setSidebarOpen(false);
      }
    };
  
    window.addEventListener('resize', handleResize);
    handleResize();
  
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  const handleCloseSidebar = () => {
    if (isMobile && sidebarOpen) {
      setSidebarOpen(false);
    }
  };

  if (error) {
    return <p style={{ color: 'red' }}>{error}</p>;
  }

  const totalProspectos = Array.isArray(dashboardData?.prospectos?.generales)
    ? dashboardData.prospectos.generales.reduce((acc, item) => acc + (item.total_prospectos || 0), 0)
    : dashboardData?.prospectos?.generales?.total_prospectos || 0 || 0;
  const totalAlumnos = Array.isArray(dashboardData?.alumnos?.generales)
    ? dashboardData.alumnos.generales.reduce((acc, item) => acc + (item.total_alumnos || 0), 0)
    : dashboardData?.alumnos?.generales?.total_alumnos || 0 || 0;
  const totalBajas = Array.isArray(dashboardData?.bajas?.generales) // <-- AÑADE ESTO
    ? dashboardData.bajas.generales.reduce((acc, item) => acc + (item.total_bajas || 0), 0)
    : 0;

  return (
    <div className="dashboard-container">
      {(!isMobile || (isMobile && sidebarOpen)) && (
        <Sidebar 
          onLogoClick={() => { if (isMobile) setSidebarOpen(false); }}
          onLinkClick={handleCloseSidebar}
        />
      )}
      <div className="main-content" onClick={handleCloseSidebar}>
        {/* Card principal de título y fechas, fuera de cualquier contenedor extra */}
        <div className="dashboard-title-card">
          {isMobile && (
            <button 
              className="menu-toggle"
              onClick={toggleSidebar}
              aria-label="Abrir menú"
            >
              <i className="fas fa-bars"></i>
            </button>
          )}
          <div className="dashboard-title-section">
            <h1 className="dashboard-title">Dashboard</h1>
            <span className="dashboard-title-sub">Panel principal de control</span>
          </div>
          <div className="dashboard-title-dates">
            <div className="dashboard-title-date-group">
              <label>Inicio</label>
              <div className="dashboard-title-date-input-wrapper">
                <DatePicker
                  selected={parseDateString(startDate)}
                  onChange={date => {
                    setStartDate(formatDateToString(date));
                    handleDateChange();
                  }}
                  dateFormat="yyyy-MM-dd"
                  className="custom-datepicker dashboard-title-datepicker"
                  placeholderText="Fecha inicio"
                  popperPlacement="bottom"
                  calendarClassName="custom-calendar"
                  showPopperArrow={false}
                  locale="es"
                />
                <svg className="calendar-icon" viewBox="0 0 24 24"><path d="M7 2v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V2h-2v2H9V2H7zm12 18H5V8h14v12zm-7-7h5v2h-5v-2z"/></svg>
              </div>
            </div>
            <div className="dashboard-title-date-group">
              <label>Fin</label>
              <div className="dashboard-title-date-input-wrapper">
                <DatePicker
                  selected={parseDateString(endDate)}
                  onChange={date => {
                    setEndDate(formatDateToString(date));
                    handleDateChange();
                  }}
                  dateFormat="yyyy-MM-dd"
                  className="custom-datepicker dashboard-title-datepicker"
                  placeholderText="Fecha fin"
                  popperPlacement="bottom"
                  calendarClassName="custom-calendar"
                  showPopperArrow={false}
                  locale="es"
                />
                <svg className="calendar-icon" viewBox="0 0 24 24"><path d="M7 2v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-2V2h-2v2H9V2H7zm12 18H5V8h14v12zm-7-7h5v2h-5v-2z"/></svg>
              </div>
            </div>
            {isFilterChanged && (
              <button onClick={resetFilters} className="cancel-btn dashboard-title-reset-btn">
                <FaChartBar />
              </button>
            )}
          </div>
        </div>
        {/* El resto del contenido va debajo del card principal */}
        <div className="stats-grid">
          <div className="stat-card">
            <FaUsers className="stat-icon" />
            <div className="stat-content">
              <h3>Total Prospectos</h3>
              <p className="stat-value">{totalProspectos}</p>
            </div>
          </div>
          <div className="stat-card">
            <FaUserGraduate className="stat-icon" />
            <div className="stat-content">
              <h3>Total Alumnos</h3>
              <p className="stat-value">{totalAlumnos}</p>
            </div>
          </div>
       
          <div className="stat-card">
            <FaUser className="stat-icon"/>
            <div className="stat-content">
              <h3>Total Bajas</h3>
              <p className="stat-value">{totalBajas}</p>
            </div>
          </div>
        </div>  
        <div className="charts-container">
          <div className="chart-box">
            <LineChartProspectosAlumnos
              prospectos={dashboardData?.prospectos?.generales}
              alumnos={dashboardData?.alumnos?.generales}
              bajas={dashboardData?.bajas?.generales}
            />
          </div>
        </div>
        <h2 className="section-title">Distribuciones por Campo</h2>
        
        <div className="charts-container">
          <div className="chart-box">
            <PieChartDistribution
              dataArray={dashboardData?.prospectos?.tipo_red_social}
              field="tipo_red_social"
              title="Tipo de Red Social (Prospectos)"
            />
          </div>
          <div className="chart-box">
            <PieChartDistribution
              dataArray={dashboardData?.prospectos?.estado_proceso}
              field="estado_proceso"
              title="Estado del Proceso (Prospectos)"
            />
          </div>
          <div className="chart-box">
            <PieChartDistribution
              dataArray={dashboardData?.prospectos?.curso_interes}
              field="curso_interes"
              title="Curso de Interés (Prospectos)"
            />
          </div>
          <div className="chart-box">
            <PieChartDistribution
              dataArray={dashboardData?.prospectos?.horario_preferencia}
              field="horario_preferencia"
              title="Horario de Preferencia (Prospectos)"
            />
          </div>
        </div>
      </div>
      {isMobile && sidebarOpen && (
        <div className="overlay" onClick={handleCloseSidebar}></div>
      )}
    </div>
  );
}

export default DashboardPage;
